import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as Styled from './text-button.styles';
export const TextButton = ({ children, className, disabled = false, ellipsis, error, fontWeight, href, icon: Icon, iconAfter, innerRef, loading, onClick, size = 'medium', sizeConfined, sizeWide, to, type, ...props }) => {
    const iconSize = size === 'small' ? 18 : 24;
    const iconOnly = !children;
    const commonProps = {
        $ellipsis: ellipsis,
        $error: error,
        $fontWeight: fontWeight,
        $iconAfter: iconAfter,
        $iconOnly: iconOnly,
        $size: size,
        $sizeConfined: sizeConfined,
        $sizeWide: sizeWide,
        'aria-label': loading ? 'loading' : null,
        'data-xds': 'TextButton',
        className,
        disabled: disabled || loading,
        onClick,
        ref: innerRef,
    };
    const buttonContent = (_jsxs(Styled.InnerContent, { "$ellipsis": ellipsis, children: [!loading && Icon && (_jsx(Styled.IconContainer, { "$iconSize": iconSize, "$iconAfter": iconAfter, children: _jsx(Icon, { width: iconSize, height: iconSize }) })), loading && (_jsx(Styled.Loading, { "$size": size, "$sizeConfined": sizeConfined, "$sizeWide": sizeWide, "aria-hidden": "true" })), _jsx(Styled.Text, { "$ellipsis": ellipsis, "$loading": loading, children: children })] }));
    return (_jsx(React.Fragment, { children: to || href ? (_jsx(Styled.RouterTextButton, { ...(to && { to }), ...(href && { href }), ...commonProps, ...props, children: buttonContent })) : (_jsx(Styled.TextButton, { type: type, ...commonProps, ...props, children: buttonContent })) }));
};
TextButton.displayName = 'TextButton';
//# sourceMappingURL=text-button.js.map